import { render, staticRenderFns } from "./EstoqueBadge.vue?vue&type=template&id=c8ce1798&scoped=true&"
import script from "./EstoqueBadge.vue?vue&type=script&lang=js&"
export * from "./EstoqueBadge.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueBadge.vue?vue&type=style&index=0&id=c8ce1798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ce1798",
  null
  
)

export default component.exports